import React, { useEffect, useMemo, useState } from 'react';
import style from './style.module.scss';
import { useTheme } from '@material-ui/core/styles';
import { IProps, IHandlers, classPrefix } from './types';
import {Button, Link, Typography, Checkbox, Paper, withStyles, Grid } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {renderIf} from "app/services/reactUtils.service";
import AppThemeService from 'app/services/theme/appTheme.service';
import classNames from 'classnames';
import { IDiaryTheme } from 'app/types/common.types';
import NetworkConnectionService from 'external-services/network-connection-service/index';
import FlagPhonePickerValidationHelper from 'external-components/flag-phone-picker-react/FlagPhonePickerValidationHelper';
import MuiTextField from '@material-ui/core/TextField';
import { ICustomer } from 'shared-types/SharedTypes';
import CustomerService from 'app/services/customer/customer.service';
import SimpleDialogActions from 'app/actions/simpleDialog.actions';
import PaymentValidationService from 'app/services/paymentValidation/paymentValidation.service';
import { APP_COLORS, Colors } from 'design-v2/globals/colors/colors';


const NS = 'PaymentLinkInfo';

const {palette} = AppThemeService.getAppTheme();

const FormControlLabel = withStyles({
  root: {
    padding: 0,
    [`& .${classPrefix}-MuiCheckbox-root`]: {
      marginLeft: 8,
      marginRight: 6
    },
  }
})(MuiFormControlLabel);

const TextField = withStyles({
  root: {
    [`& .${classPrefix}-MuiFormHelperText-root`]: {
      marginTop: '-2px',
      fontSize: '12px',
    },
    [`& .${classPrefix}-MuiFormLabel-root`]: {
      fontSize: '1.6rem',
    },
    [`& .${classPrefix}-MuiInput-underline:before`]: {
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    [`& .${classPrefix}-MuiInput-underline.Mui-error:after`]: {
      borderBottomWidth: '1px',
    },
    [`& .${classPrefix}-MuiInput-underline.Mui-focused.Mui-error:after`]: {
      borderBottomWidth: '2px',
      borderBottomColor: Colors.get(APP_COLORS.clrNbiMagenta),
    },
    [`& .${classPrefix}-MuiInput-root:hover:before`]: {
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
    },
    [`& .${classPrefix}-MuiInputBase-input`]: {
      minWidth: '260px',
    }
  }
})(MuiTextField);
const WarnAlert = withStyles({
  message: {
    display: 'block'
  },
  root: {
    backgroundColor: palette.warning.main + ' !important',
    color: "#fff !important"
  },
  icon: {
    paddingTop: 8
  }
})(MuiAlert as any);


// just exported for tests
export const ERROR_MSG = 'Sorry, there was a problem emailing the link.';
export const SUCCESS_MSG = 'Operation done successfully.';

export default function PaymentLinkInfo({
  paymentUrl, email, mobilePhone, saveEmailToCustomer, savePhoneNumberToCustomer,isPhoneValid,
  isEmailValid, validEmailMessage, validPhoneMessage, hideDetails, showImage, smsEnabled,
  isStandbyPending, isBookingExpired, isStandbyBookingType, venueCountry, customer, booking, isShorterContainerInEditBooking,

  handleEmailChanged, handleMobilePhoneChanged, handleSaveEmailToCustomerChanged, handleSavePhoneNumberToCustomerChanged,
  handleSendLinkPayment, handleSendSmsLinkPayment, handleSave, handleOpenStandbyPayments, handleSaveButtonClick,handleCloseButtonClick, disableEmailSmsNotification,
  enableBookedByOnDiary, bookedByEmail, bookedByMobilePhone, handleSaveBookedByEmailToCustomerChanged, isBookedByEmailValid, handleBookedByEmailChanged, handleBookedByMobilePhoneChanged,
  handleSaveBookedByPhoneNumberToCustomerChanged, saveBookedByPhoneNumberToBooking, saveBookedByEmailToBooking, validBookedByEmailMessage, isBookedByPhoneValid, validBookedByPhoneMessage,
}: IProps & IHandlers) {

  const [isOverlayShown, setIsOverlayShown] = useState<boolean>(hideDetails);
  const [successMsg, setSuccessMsg] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [btnsDisabled, setBtnsDisabled] = useState<boolean>(false);
  const [emailIsDirty, setEmailIsDirty] = useState<boolean>(false);
  const [mobilePhoneIsDirty, setMobilePhoneIsDirty] = useState<boolean>(false);
  const [bookedByEmailIsDirty, setBookedByEmailIsDirty] = useState<boolean>(false);
  const [bookedByPhoneIsDirty, setBookedByPhoneIsDirty] = useState<boolean>(false);
  const [standbyPaymentError, setStandbyPaymentError] = useState<string>('');
  const [isStandbyPaymentSending, setIsStandbyPaymentSending] = useState<boolean>(false);

  const showStandbyPendingLinkBtn = isStandbyPending && !isBookingExpired;
  const showTextLink = !isStandbyPending && !isBookingExpired && paymentUrl; //also, false when paymentURL is empty string

  // Don't want the send button for standby because it would go against the SB workflow
  const showSendBtn = !isStandbyBookingType;
  const enableNotifications = NetworkConnectionService.isNavigatorOnline() && NetworkConnectionService.isApiStatusOnline();

  const savePopup = (originalCustomer: ICustomer, newCustoemr: ICustomer, saveClick:() => void) => {
    const diffInfoList = CustomerService.checkDifference(originalCustomer, newCustoemr as ICustomer);
    const dialogMessage = `You are about to update an existing customer record, would you like to proceed? <div>Current Details: ${originalCustomer.fullName || ''} ${originalCustomer.phone && originalCustomer.phone.trim() != '' ? `(${originalCustomer.phone})` : ''} ${originalCustomer.email || ''}</div>`;
    const headerMsg = 'Save confirmation';

    SimpleDialogActions.showDialog({
      description: dialogMessage,
      title: headerMsg,
      confirmText: 'Continue',
      rejectText: 'Cancel',
      handleConfirm: () => {
        saveClick();
        SimpleDialogActions.hideDialog();
      },
      handleReject: () => {
        SimpleDialogActions.hideDialog();
      },
      diffInfoList
    });
  };
  const sendEmail = (isBookedBy: boolean) => {
    setBtnsDisabled(true);
    handleSendLinkPayment(isBookedBy)
      .then((success: boolean) => {
        if (success) {
          setSuccessMsg(SUCCESS_MSG);
        } else {
          setBtnsDisabled(false);
          setErrorMsg(ERROR_MSG);
        }
      });
  }
  const sendSms = (isBookedBy: boolean) => {
    setBtnsDisabled(true);
    handleSendSmsLinkPayment(isBookedBy)
      .then((success: boolean) => {
        if (success) {
          setSuccessMsg(SUCCESS_MSG);
        } else {
          setBtnsDisabled(false);
          setErrorMsg(ERROR_MSG);
        }
      });
  }
  const handleSmsSaveClick = () => {
    if (savePhoneNumberToCustomer && PaymentValidationService.paymentPhone?.replace(/ /g, '') !== customer?.phone?.replace(/ /g, '')) {
      savePopup(customer, {...customer, phone: PaymentValidationService.paymentPhone}, () => {
        sendSms(false);
      })
    } else {
      return sendSms(false);
    }
  }
  const handleBookedBySmsSaveClick = () => {
      return sendSms(true);
  }
  const handleEmailSaveClick = () => {
    if (saveEmailToCustomer && PaymentValidationService.paymentEmail !== customer?.email) {
      savePopup(customer, {...customer, email: PaymentValidationService.paymentEmail}, () => {
        sendEmail(false);
      })
    } else {
      return sendEmail(false);
    }
  }
  const handleBookedByEmailSaveClick = () => {
      return sendEmail(true);
  }
  const handleSaveClick = () => {
    if ((saveEmailToCustomer || savePhoneNumberToCustomer) && (PaymentValidationService.paymentPhone?.replace(/ /g, '') !== customer?.phone?.replace(/ /g, '')
      || PaymentValidationService.paymentEmail !== customer?.email)) {
      savePopup(customer,
        {...customer, email: saveEmailToCustomer ? PaymentValidationService.paymentEmail : customer.email,
          phone: savePhoneNumberToCustomer ? PaymentValidationService.paymentPhone : customer.phone}, () => {
        handleSaveButtonClick();
      })
    } else {
      handleSaveButtonClick();
    }
  }
  useEffect(() => {
    setIsOverlayShown(hideDetails);
  }, [hideDetails]);

  const renderSendEmailPhone = useMemo(() => {
    return (showSendBtn && (email || emailIsDirty)) || (showSendBtn && (mobilePhone || mobilePhoneIsDirty) && smsEnabled)
  }, [email, emailIsDirty, showSendBtn, mobilePhone, mobilePhoneIsDirty, smsEnabled])

  const {palette: {success, error}} = useTheme<IDiaryTheme>();
  return (
    <Paper elevation={2} className={classNames({
      [style.root]: true,
      [style.shorterContainerInEditBooking]: isShorterContainerInEditBooking,
    })}>

      {renderIf(isOverlayShown, () => (
        <div data-testid="overlay" className={style.overlay}>
          <Typography variant="body1">
            Booking Payment URL details have been hidden because the booking is on the standby list without a confirmed
            table.&nbsp;<span className={style.underlinedText}>This is not a confirmed booking.</span>
          </Typography>

          <div className={style.overlayFooter}>
            <Button data-testid="overlayBtn"
              variant="contained" color="primary" onClick={() => setIsOverlayShown(false)}>
              VIEW ANYWAY?
            </Button>
          </div>
        </div>
      ))}


      <div className={classNames({
        [style.contentWrapHide]: isOverlayShown,
        [style.contentWrapShowImage]: showImage
      })}>
        {renderIf(showImage, () => (
          <div className={style.imageColumn} data-testid="imageSend">
            <img className={style.imgSend} />
          </div>
        ))}

        <div className={style.contentColumn} >
          {
            renderIf(showTextLink, () => (
              <Grid container direction='row'>
                <Grid item xs={12}>
                  <Typography variant="h5" >Booking Payment URL</Typography>
                </Grid>
              </Grid>
            ))
          }

          {renderIf(showStandbyPendingLinkBtn, () => (
            <>
              <Button variant="contained"
                data-testid="standby-pending-link-btn"
                className={style.spLinkBtn}
                endIcon={<ArrowForwardIcon className={style.spLinkBtnIcon} />}
                aria-label="Standby list payment"
                disabled={isStandbyPaymentSending}
                onClick={() => {
                  setStandbyPaymentError('');
                  setIsStandbyPaymentSending(true);
                  handleOpenStandbyPayments()
                    .then(({success, reason}) => {
                      setIsStandbyPaymentSending(false);
                      if (!success) {
                        setStandbyPaymentError(reason);
                      }
                    });
                }}>
                Save &amp; Open Payment Page
              </Button>
              {renderIf(standbyPaymentError, () => (
                <Typography variant="body1" color="error"
                  className={style.errorMsg}
                  data-testid="standby-pending-link-error-message">
                  {`Sorry, there was a problem: "${standbyPaymentError}"`}
                </Typography>
              ))}
              <WarnAlert severity="warning" variant="filled" className={style.warnMsg} data-testid="standby-pending-link-message">
                Pressing the above link is the same as the customer pressing "Pay Now" on their Standby List acceptance email.
                The same time constraints will apply and any changes to this open booking will be saved.
              </WarnAlert>
            </>
          ))}

          {renderIf(isBookingExpired, () => (
            <WarnAlert severity="warning" variant="filled" className={style.warnMsg} data-testid="expired-message">
              No link available. Booking expired.
            </WarnAlert>
          ))}
          {/*------------------------customer----------------------------*/}
          {enableBookedByOnDiary && (booking.bookedBy?.phone || booking.bookedBy?.email) && (customer?.email || customer?.phone) && (
            <div className={style.customerHeader} data-testid="customerTitle">
              <span className={style.title}>Customer</span>
            </div>
            )}
          <div className={classNames({
            [style.sendPaymentLinkContainer]: true,
            [style.sendPaymentLinkContainerPadding]: showTextLink,
            [style.sendPaymentLinkContainerNoMarginPadding]: !renderSendEmailPhone
          })}>
            {renderIf(showSendBtn && (email || emailIsDirty) , () => (
              <div className={style.sendEmailContainer}>
                <TextField
                  data-testid="emailTextField"
                  disabled={btnsDisabled || !enableNotifications}
                  className={style.emailField}
                  error={emailIsDirty && !isEmailValid}
                  helperText={emailIsDirty && !isEmailValid && validEmailMessage ? validEmailMessage : ''}
                  label="Email (required)"
                  value={email}
                  onChange={(evt) => {
                  setEmailIsDirty(true);
                  setSuccessMsg('');
                  setErrorMsg('');
                  handleEmailChanged(evt.target.value);
                }} />

                <FormControlLabel
                  className={style.checkboxWrap}
                  control={
                    <Checkbox
                      data-testid="replaceCheckbox"
                      disabled={!isEmailValid || !email || btnsDisabled || !enableNotifications}
                      className={style.checkbox}
                      disableRipple={true}
                      checked={saveEmailToCustomer}
                      onChange={(evt, isChecked) => {
                        /**
                         * Notifies the parent component of the change. We could wait for this
                         * to then cycle back into 'saveToCustomer' for the UI to update, but
                         * there is a noticable delay.
                         */
                        handleSaveEmailToCustomerChanged(isChecked);
                      }}
                      icon={<CheckBoxOutlineBlankIcon fontSize="default"/>}
                      checkedIcon={<CheckBoxIcon fontSize="default" color="primary"/>}
                    /> as any
                  }
                  label="Update current customer email address"
                />
                <div className={style.sendAndOpenLinkBtnContainer}>
                  <div className={style.sendEmailWrap}>
                    {renderIf(showSendBtn, () => (
                      <Button
                        data-testid="sendBtn"
                        disabled={!isEmailValid || !email || btnsDisabled || !enableNotifications || disableEmailSmsNotification} variant="contained" color="primary" className={style.btnSend}
                        onClick={handleEmailSaveClick}
                      >
                        SEND EMAIL {saveEmailToCustomer ? '& SAVE' : ''}
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            ))}

            {renderIf(showSendBtn && (mobilePhone || mobilePhoneIsDirty) && smsEnabled, () => (
              <div className={style.sendSmsContainer}
              data-testid="sendSmsLinkContainer">
                <FlagPhonePickerValidationHelper
                  customerCountry={venueCountry}
                  customerPhone={mobilePhone}
                  classPrefix='PaymentLinkInfo'
                  handlePhoneChange={(value) => {
                    setMobilePhoneIsDirty(true);
                    setSuccessMsg('');
                    setErrorMsg('');
                    handleMobilePhoneChanged(value);
                }}
                label={'Phone (required)'}
                validationError={mobilePhoneIsDirty && !isPhoneValid && validPhoneMessage ? validPhoneMessage : ''}
                />
                <FormControlLabel
                  className={style.checkboxWrap}
                  control={
                    <Checkbox
                      disabled={!isPhoneValid || !mobilePhone || btnsDisabled || !enableNotifications}
                      className={style.checkbox}
                      disableRipple={true}
                      checked={savePhoneNumberToCustomer}
                      onChange={(evt, isChecked) => {
                        /**
                         * Notifies the parent component of the change. We could wait for this
                         * to then cycle back into 'saveToCustomer' for the UI to update, but
                         * there is a noticable delay.
                         */
                        handleSavePhoneNumberToCustomerChanged(isChecked);
                      }}
                      icon={<CheckBoxOutlineBlankIcon fontSize="default"/>}
                      checkedIcon={<CheckBoxIcon fontSize="default" color="primary"/>}
                    /> as any
                  }
                  label="Update current customer mobile"
                />
                <div className={style.sendAndOpenLinkBtnContainer}>
                  {renderIf( showSendBtn, () => (
                    <Button data-testid="sendBtnSms"
                      disabled={!isPhoneValid || !mobilePhone || btnsDisabled || !enableNotifications || disableEmailSmsNotification} variant="contained" color="primary" className={style.btnSend}
                      onClick={handleSmsSaveClick}
                    >
                      SEND SMS {savePhoneNumberToCustomer ? '& SAVE' : ''}
                    </Button>
                  ))}
                </div>
              </div>
            ))}
          </div>
          {/*------------bookedBy----------------------------------------*/}
          {enableBookedByOnDiary && (booking.bookedBy?.phone || booking.bookedBy?.email) && (
            <div data-testid='bookedBySection'>
              <div className={classNames({
                [style.divider]: customer?.email || customer?.phone,
              })}>
                <span className={style.title}>Booked By</span>
              </div>

              <div className={classNames({
                [style.sendPaymentLinkContainer]: true,
                [style.sendPaymentLinkContainerPadding]: showTextLink
              })}>
                {renderIf(showSendBtn && (bookedByEmail || bookedByEmailIsDirty) , () => (
                  <div className={style.sendEmailContainer}>
                    <TextField
                      data-testid="emailTextFieldBookedBy"
                      disabled={btnsDisabled || !enableNotifications}
                      className={style.emailField}
                      error={bookedByEmailIsDirty && !isBookedByEmailValid}
                      helperText={bookedByEmailIsDirty && !isBookedByEmailValid && validBookedByEmailMessage ? validBookedByEmailMessage : ''}
                      label="Email (required)" value={bookedByEmail}
                      onChange={(evt) => {
                        setBookedByEmailIsDirty(true);
                        setSuccessMsg('');
                        setErrorMsg('');
                        handleBookedByEmailChanged(evt.target.value);
                      }} />

                    <FormControlLabel
                      className={style.checkboxWrap}
                      control={
                        <Checkbox
                          data-testid="replaceCheckboxBookedBy"
                          disabled={!isBookedByEmailValid || !bookedByEmail || btnsDisabled || !enableNotifications}
                          className={style.checkbox}
                          disableRipple={true}
                          checked={saveBookedByEmailToBooking}
                          onChange={(evt, isChecked) => {
                            /**
                             * Notifies the parent component of the change. We could wait for this
                             * to then cycle back into 'saveToCustomer' for the UI to update, but
                             * there is a noticable delay.
                             */
                            handleSaveBookedByEmailToCustomerChanged(isChecked);
                          }}
                          icon={<CheckBoxOutlineBlankIcon fontSize="default"/>}
                          checkedIcon={<CheckBoxIcon fontSize="default" color="primary"/>}
                        /> as any
                      }
                      label="Update bookedBy email address"
                    />
                    <div className={style.sendAndOpenLinkBtnContainer}>
                      <div className={style.sendEmailWrap}>
                        {renderIf(showSendBtn, () => (
                          <Button
                            data-testid="sendBtnBookedBy"
                            disabled={!isBookedByEmailValid || !bookedByEmail || btnsDisabled || !enableNotifications || booking.bookedBy.disableEmailSmsNotification} variant="contained" color="primary" className={style.btnSend}
                            onClick={handleBookedByEmailSaveClick}
                          >
                            SEND EMAIL {saveBookedByEmailToBooking ? '& SAVE' : ''}
                          </Button>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}

                {renderIf(showSendBtn && (bookedByMobilePhone || bookedByPhoneIsDirty) && smsEnabled, () => (
                  <div className={style.sendSmsContainer}
                       data-testid="sendBookedBySmsLinkContainer"
                  >
                    <FlagPhonePickerValidationHelper
                      classPrefix='PaymentLinkInfo'
                      customerCountry={venueCountry}
                      customerPhone={bookedByMobilePhone}
                      handlePhoneChange={(value) => {
                        setBookedByPhoneIsDirty(true);
                        setSuccessMsg('');
                        setErrorMsg('');
                        handleBookedByMobilePhoneChanged(value);
                      }}
                      label={'Phone (required)'}
                      validationError={bookedByPhoneIsDirty && !isBookedByPhoneValid && validBookedByPhoneMessage ? validBookedByPhoneMessage : ''}
                    />
                    <FormControlLabel
                      className={style.checkboxWrap}
                      control={
                        <Checkbox
                          data-testid="phoneCheckboxBookedBy"
                          disabled={!isBookedByPhoneValid || !bookedByMobilePhone || btnsDisabled || !enableNotifications}
                          className={style.checkbox}
                          disableRipple={true}
                          checked={saveBookedByPhoneNumberToBooking}
                          onChange={(evt, isChecked) => {
                            /**
                             * Notifies the parent component of the change. We could wait for this
                             * to then cycle back into 'saveToCustomer' for the UI to update, but
                             * there is a noticable delay.
                             */
                            handleSaveBookedByPhoneNumberToCustomerChanged(isChecked);
                          }}
                          icon={<CheckBoxOutlineBlankIcon fontSize="default"/>}
                          checkedIcon={<CheckBoxIcon fontSize="default" color="primary"/>}
                        /> as any
                      }
                      label="Update bookedBy mobile"
                    />
                    <div className={style.sendAndOpenLinkBtnContainer}>
                      {renderIf( showSendBtn, () => (
                        <Button data-testid="sendBtnSmsBookedBy"
                                disabled={!isBookedByPhoneValid || !bookedByMobilePhone || btnsDisabled || !enableNotifications || booking.bookedBy.disableEmailSmsNotification} variant="contained" color="primary" className={style.btnSend}
                                onClick={handleBookedBySmsSaveClick}
                        >
                          SEND SMS {saveBookedByPhoneNumberToBooking ? '& SAVE' : ''}
                        </Button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            )}

          {showSendBtn && !enableNotifications && (
            <Typography className={style.offlineMsg} style={{color: error.main }}  >
              Notifications not available in offline mode
            </Typography>
          )}

          {renderIf(showTextLink && isStandbyBookingType, () => (
            <WarnAlert severity="warning" variant="filled" className={style.warnMsg} data-testid="sb-payment-link-warning-message">
              Completing the payment link above will automatically send a booking confirmation email to the customer.
              Please ensure a table is added to this standby booking and the status is manually updated.
            </WarnAlert>
          ))}

          <div className={style.sendFooter}>
            {renderIf(successMsg || errorMsg, () => (
              <Typography data-testid="statusMsg"
                className={style.statusMsg} style={{color: errorMsg ? error.main : success.main }}  >
                {errorMsg || successMsg}
              </Typography>
            ))}
            {renderIf(showTextLink, () => (
              <Button
                data-testid="copyLinkBtn"
                disabled={btnsDisabled} variant="contained" color="primary" className={style.btnLink}
                onClick={async () => {
                  await navigator.clipboard.writeText(paymentUrl)
                }}
              >
                COPY LINK
              </Button>
            ))}
            {renderIf(showTextLink, () => (
              <Button
                data-testid="openLinkBtn"
                disabled={btnsDisabled} variant="contained" color="primary" className={style.btnLink}
                onClick={() => {
                  window.open(paymentUrl, "_blank");
                }}
              >
                OPEN LINK
              </Button>
            ))}
            {renderIf(handleSave, () => (
              <>
                <Button data-testid="saveBtn"
                  disabled={(!isEmailValid || !saveEmailToCustomer) && (!isPhoneValid || !savePhoneNumberToCustomer) && (!isBookedByEmailValid || !saveBookedByEmailToBooking) && (!isBookedByPhoneValid || !saveBookedByPhoneNumberToBooking)}
                  variant="contained" color="primary"
                  onClick={() => { handleSaveClick()}}
                  className={style.btnSave}>
                  { 'SAVE' }
                </Button>
                <Button data-testid="closeBtn"
                  variant="contained" color="primary" onClick={() => {
                  handleCloseButtonClick();
                  }} className={style.btnSave}>
                    {'CLOSE'}
                  </Button>
                </>
            ))}

          </div>

        </div>
      </div>
    </Paper>
  )
}

